"use client";

import MyDivider from "@/components/ui_tools/divider";
import { FaNotesMedical } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMailOutline } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";

import { CgMathMinus, CgMathPlus } from "react-icons/cg";
import { useEffect, useState } from "react";
import { ReserveArticle } from "@/types/reserveArticle";
import { MdCancel, MdDelete } from "react-icons/md";
import { RiSendPlaneFill } from "react-icons/ri";
import { MdDeleteSweep } from "react-icons/md";
import { sendMailAction } from "@/action/send_mail_action";
import { FaHospitalSymbol } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import { creatingCommande } from "@/service/commande";

export default function CartContainer({
  modalCart,
  clickOutside,
}: {
  modalCart: boolean;
  clickOutside: (e: any) => void;
}) {
  const [cartListIsLoading, setCartListIsLoading] = useState(false);
  const [items, setItems] = useState<ReserveArticle[]>([]);

  const [postingLoading, setPostingLoading] = useState(false);

  const notifyError = (msg: string) => toast.error(msg);
  const notify = (msg: string) => toast.success(msg);

  useEffect(() => {
    const loadCategories = async () => {
      setCartListIsLoading(true);

      // const html = await render(<CartEmailContainer items={items} />);

      // console.log("HHTTMMLL....., ", html);

      try {
        const existing = JSON.parse(localStorage.getItem("cart") || "[]");
        setItems(existing);
      } catch (error) {
        console.error(error);
      } finally {
        setCartListIsLoading(false); // ✅ always runs
      }
    };
    loadCategories();
  }, [modalCart]);

  // ✅ Increase quantity
  const increaseQty = (designation: string) => {
    const updated = items.map((item) =>
      item.designation === designation
        ? { ...item, conditionnement: item.conditionnement + 1 }
        : item
    );
    setItems(updated);
    localStorage.setItem("cart", JSON.stringify(updated));
  };

  const decreaseQty = (designation: string) => {
    const updated = items.map((item) =>
      item.conditionnement > 1 && item.designation === designation
        ? { ...item, conditionnement: item.conditionnement - 1 }
        : item
    );
    setItems(updated);
    localStorage.setItem("cart", JSON.stringify(updated));
  };

  // ✅ Remove item by index
  const removeFromCart = (index: number) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated);
    localStorage.setItem("cart", JSON.stringify(updated));
  };

  const clearCart = () => {
    console.log("CLEARING THE CART");

    setItems([]);
    localStorage.removeItem("cart");

    window.location.reload();
  };

  const totalPrice = items.reduce(
    (sum, item) => sum + item.conditionnement * item.price,
    0
  );

  let lastCartItem = [] as ReserveArticle | any;

  if (items) {
    lastCartItem = items[items.length - 1] as ReserveArticle;
  }

  // console.log("lAST ITEM ::: ", items[items.length - 1]);

  // console.log("CART PAGE ITMES :::: ", items, " TOTAL : ", totalPrice);

  if (cartListIsLoading) {
    return (
      <div
        onClick={(e: any) => clickOutside(e)}
        className={`fixed z-30 h-screen top-0 left-0 w-full flex justify-end bg-[#111]/30  transition-all duration-300 ${
          modalCart
            ? " opacity-100 pointer-events-auto "
            : " pointer-events-none opacity-0 "
        } `}
      >
        <ToastContainer />
        <div
          className={`w-[40vw] px-4 py-2 flex flex-col gap-4 items-center bg-[#009900]/10 backdrop-blur-lg h-screen transition-all duration-300 ${
            modalCart ? "translate-x-0 " : " translate-x-full "
          } `}
        >
          <div className="animate-spin rounded-full h-16 w-16 border-b-3 border-[#007700]"></div>
          <p className="text-white"> Cart List Loading..</p>
        </div>
      </div>
    );
  }

  return (
    <div
      onClick={(e: any) => clickOutside(e)}
      className={`fixed z-60 h-screen top-0 left-0 w-full flex justify-end bg-[#111]/30  transition-all duration-300 ${
        modalCart
          ? " opacity-100 pointer-events-auto "
          : " pointer-events-none opacity-0 "
      } `}
    >
      <div
        className={`w-full  py-2 flex flex-col gap-4 items-center bg-[#009900]/10 backdrop-blur-lg h-screen overflow-y-scroll transition-all duration-300 lg:px-4 md:w-[60vw] lg:w-[40vw] ${
          modalCart ? "translate-x-0 " : " translate-x-full "
        } `}
      >
        {/* header */}
        <div className="w-full z-40 bg-[#009900]/20 rounded-md sticky top-2  flex flex-col items-center py-2  ">
          {/* cancel btn */}
          <MdCancel
            onClick={(e: any) => clickOutside(e)}
            className="absolute top-4  left-4 transition-all duration-300 text-3xl   text-white hover:opacity-40 "
          />
          <div className="  h-18 w-18 border border-white flex justify-center items-center rounded-full transition-all duration-300 cursor-pointer hover:scale-102">
            <div className="bg-white flex flex-col gap-1 justify-center items-center  h-15 w-15 rounded-full  text-white ">
              <FaNotesMedical className="text-3xl text-[#009900] " />
            </div>
          </div>
          <p className="text-sm text-white text-center ">List commande</p>
        </div>

        {/* CONTENT */}
        <div className="w-full relative flex flex-col gap-4">
          <div className="w-full flex flex-col  md:rounded-t-md gap-y-1 ">
            <table className="table-auto overflow-hidden  border-collapse text-center md:rounded-t-md ">
              <thead>
                <tr className=" border-b flex gap-1 border-[#01578C] bg-[#01578C] text-white px-1 lg:px-2 ">
                  <td className=" py-1 font-semibold flex-[1.5] text-start ">
                    Designation
                  </td>
                  <td className=" py-1 font-semibold flex-[1] ">Dosage</td>
                  <td className=" py-1 font-semibold flex-[1] ">Forme</td>
                  <td className=" py-1 font-semibold flex-[1] ">Prix</td>
                  <td className=" py-1 font-semibold flex-[1] ">
                    Conditionnement
                  </td>
                </tr>
              </thead>
              <tbody>
                {items
                  ?.sort(
                    (a, b) =>
                      new Date(b.createdAt).getTime() -
                      new Date(a.createdAt).getTime()
                  )
                  .map((item, index) => (
                    <tr key={index} className="py-1 flex px-2 mt-1 bg-white  ">
                      <td className="text-[#111]  text-start text-sm flex-[1.5] py-1  ">
                        {item.designation}
                      </td>
                      <td className="text-[#111] text-sm flex-[1] py-1  ">
                        {item.dosage}
                      </td>
                      <td className="text-[#111] text-sm flex-[1] py-1  ">
                        {item.form}
                      </td>
                      <td className="text-[#111] relative text-sm flex-[1] py-1  ">
                        $ {item.price} |{" "}
                        <span className="font-bold  ">
                          {item.price * item.conditionnement}
                        </span>
                        {/* DELETE */}
                        <div
                          onClick={() => removeFromCart(index)}
                          className="absolute flex -right-5 -top-1 transition-all duration-200 rounded-md md:hidden justify-center items-center hover:bg-black/50 cursor-pointer "
                        >
                          <MdDelete className="text-xl text-red-500 " />
                        </div>
                      </td>
                      <td className="text-[#111] text-base flex-[1] py-1 flex justify-center items-center gap-2  md:gap-4  ">
                        <p>{item.conditionnement}</p>
                        <div className=" min-h-10 relative  w-5 flex flex-col gap-1 ">
                          <div
                            onClick={() => increaseQty(item.designation)}
                            className="h-4 w-4 rounded-full bg-[#009900] text-white font-black text-xl  flex justify-center items-center cursor-pointer transition-all duration-200 hover:bg-green-950 "
                          >
                            <CgMathPlus />
                          </div>
                          <div
                            onClick={() => decreaseQty(item.designation)}
                            className="h-4 w-4 rounded-full bg-[#009900] text-white  font-black text-xl flex justify-center items-center cursor-pointer transition-all duration-200 hover:bg-green-950 "
                          >
                            <CgMathMinus />
                          </div>

                          {/* DELETE */}
                          <div
                            onClick={() => removeFromCart(index)}
                            className="absolute hidden md:left-5  md:top-2 transition-all duration-200 rounded-md md:flex justify-center items-center hover:bg-black/50 cursor-pointer "
                          >
                            <MdDelete className="text-xl text-red-500 " />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>

            {/* contact */}
            <div className="flex flex-wrap gap-x-4 gap-y-1 p-2 bg-white  ">
              <div className="flex flex-col ">
                <p className="flex items-center gap-2 text-sm  text-[#111] ">
                  {" "}
                  <span>
                    <FaHospitalSymbol />
                  </span>{" "}
                  Structure
                </p>
                <p className="text-[#9d9d9d] text-sm ">
                  {" "}
                  {lastCartItem && lastCartItem?.structure}{" "}
                </p>
              </div>
              <MyDivider className="h-10 w-[1px] " />
              <div className="flex flex-col ">
                <p className="flex items-center gap-2 text-sm  text-[#111] ">
                  {" "}
                  <span>
                    <FaPhoneAlt />
                  </span>{" "}
                  Phone
                </p>
                <p className="text-[#9d9d9d] text-sm ">
                  {" "}
                  {lastCartItem && lastCartItem?.tel}{" "}
                </p>
              </div>
              <MyDivider className="h-10 w-[1px] " />
              <div className="flex flex-col ">
                <p className="flex items-center gap-2 text-sm  text-[#111] ">
                  {" "}
                  <span>
                    <IoMailOutline />
                  </span>{" "}
                  Email
                </p>
                <p className="text-[#9d9d9d] text-sm  ">
                  {" "}
                  {lastCartItem && lastCartItem?.email}{" "}
                </p>
              </div>
              <MyDivider className="h-10 w-[1px] " />
              <div className="flex flex-col ">
                <p className="flex items-center gap-2 text-sm  text-[#111] ">
                  {" "}
                  <span>
                    <FaLocationDot />
                  </span>{" "}
                  Adress
                </p>
                <p className="text-[#9d9d9d] text-sm ">
                  {" "}
                  {lastCartItem && lastCartItem?.adress}{" "}
                </p>
              </div>
            </div>

            {/* QUATITY */}
            <div className="bg-[#009900] p-2 w-full flex justify-between ">
              <p className="text-lg font-semibold text-white ">Total</p>
              <div className="flex gap-4 items-center ">
                <MyDivider className="h-5 w-[1px] bg-white " />
                <p className="text-white"> $ {totalPrice ?? 0} </p>
              </div>
            </div>
          </div>

          {/* buttons */}
        </div>

        <div className="p-2  w-full sticky  bottom-2 z-10 bg-[#fff]/20 rounded-md px-4 flex flex-col gap-2 ">
          <form
            action={async () => {
              try {
                const res = await sendMailAction(items as any);
                // const data = await res?.json();s

                console.log(
                  "SENDING MAIL RESPONSE DATA FORM CLIENT SIDE ;;;; ",
                  res?.data
                );

                if (res?.data.data == null) {
                  console.log(
                    " ::::::::::::::::::: error THE RESPONSE DATA ::::: ..... ",
                    res.data.error
                  );
                  notifyError(
                    "Un probleme est survenu, veiller verifiez votre connexion puis reessayer svp! "
                  );
                  return;
                }

                if (res.data.data) {
                  console.log(" :::::::### FOR SENDING ..... ", res);

                  const postRes = await creatingCommande(items as any);

                  console.log(" ----- ** :::: ", postRes, " ::: ---- *****");

                  notify("Commade envoyee avec succee!!!");
                  clearCart();
                }
              } catch (error) {
                console.log(
                  "ERROR OCCURED WHEN TRYING TO POST FROM THE CLIENT CALLED ACTION ::::: ",
                  error
                );
              } finally {
                setPostingLoading(false);
              }
            }}
          >
            <button
              disabled={items.length == 0}
              type="submit"
              onClick={() => {
                setPostingLoading(true);
              }}
              className="flex gap-2 justify-center items-center   bg-[#009900] text-white font-medium w-full py-1 cursor-pointer text-center rounded-full  transition-all duration-300 disabled:bg-gray-500 hover:bg-[#005e00] hover:scale-102 "
            >
              {postingLoading ? (
                <div className="flex justify-center gap-2">
                  <span>Entrain de poster la commande...</span>
                  <span className="animate-spin rounded-full h-5 w-5 border-b-3 border-white " />
                </div>
              ) : (
                <div className="flex items-center gap-4">
                  <span>Passer la commande</span>
                  <RiSendPlaneFill className="text-2xl" />
                </div>
              )}
            </button>
          </form>
          <div
            onClick={clearCart}
            className="flex gap-2 justify-center items-center  border border-[#01578C] text-[#01578C] font-medium w-full py-1 cursor-pointer text-center rounded-full  transition-all duration-300 hover:bg-[#01578C] hover:scale-102 hover:text-white "
          >
            <span className=""> Annuler la commande</span>
            <MdDeleteSweep className="text-2xl text-shadow-sm text-shadow-[#01578C]  " />
          </div>
        </div>
      </div>
    </div>
  );
}
